import { render, staticRenderFns } from "./Pavilion.vue?vue&type=template&id=6d0bbcb2&"
import script from "./Pavilion.vue?vue&type=script&lang=js&"
export * from "./Pavilion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports